export default __webpack_public_path__ + "static/media/tutorial3-1.ed3c5882.png";